import React from 'react';
import { useSlotUniqueId } from './hooks/useSlotUniqueId';
import { useSlotHighlighting } from './hooks/useSlotHighlighting';
import { useWidgetPlugin } from './hooks/useWidgetPlugin';
import classes from './slotsPlaceholder.scss';
export const SlotsPlaceholder = (props) => {
    const { PluginComponent, isEmpty } = useWidgetPlugin(props.slotId);
    const isHighlighted = useSlotHighlighting(props.slotId);
    const slotUniqueId = useSlotUniqueId(props.slotId);
    if (isEmpty && isHighlighted) {
        return (React.createElement("div", { "data-hook": `slot-placeholder-${slotUniqueId}`, id: slotUniqueId, className: classes.slotHighlighted }));
    }
    return (React.createElement("div", { "data-hook": `slot-placeholder-${slotUniqueId}`, id: slotUniqueId, className: isHighlighted ? classes.slotHighlighted : '' },
        React.createElement(PluginComponent, null)));
};
//# sourceMappingURL=slotsPlaceholder.js.map